module.exports = __webpack_public_path__ + "img/3.a38ab833.jpg";